import { camelCase } from 'lib/utils/objectSerializer';
import { CampaignsSchedule } from './types';

export const camelCaseValues = (obj: CampaignsSchedule) => {
  Object.keys(obj).forEach((k: string) => {
    // eslint-disable-next-line no-param-reassign
    obj[k] = camelCase(obj[k]);
  });

  return obj;
};
